// Generated by web/tooling/schemagen.ts from docs/schemas/pointer.schema.json. Do not edit:
// change the schema and run `make schemas`.

import { field, isInteger, isObject, isOneOf, isString } from "../check";

const PATTERN_1 = new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$", "u");
const PATTERN_2 = new RegExp("^[a-z][a-z0-9]*$", "u");
const PATTERN_3 = new RegExp("^[a-z][a-z0-9]*[./][A-Za-z0-9._/-]*/index\\.json$", "u");
const PATTERN_4 = new RegExp("^[0-9a-f]{8}$", "u");

/** ISO 8601 UTC, to the second, with a Z suffix. */
export type Timestamp = string;

export function checkTimestamp(v: unknown, at: string): asserts v is Timestamp {
  isString(v, at, PATTERN_1, undefined, true);
}

/** A point product's live pointer, latest-<product>.json: the one mutable object, naming an issue's immutable index by path, byte length and CRC32. Which directories the path may name is the product's own rule. */
export type ProductPointer = { schemaVersion: 1; product: string; issued: Timestamp; path: string; byteLength: number; crc32: string };

export function checkProductPointer(v: unknown, at: string): asserts v is ProductPointer {
  isObject(v, at);
  const v1 = field(v, "schemaVersion", at);
  isInteger(v1, at + ".schemaVersion");
  isOneOf(v1, at + ".schemaVersion", [1]);
  const v2 = field(v, "product", at);
  isString(v2, at + ".product", PATTERN_2);
  const v3 = field(v, "issued", at);
  checkTimestamp(v3, at + ".issued");
  const v4 = field(v, "path", at);
  isString(v4, at + ".path", PATTERN_3);
  const v5 = field(v, "byteLength", at);
  isInteger(v5, at + ".byteLength", 1);
  const v6 = field(v, "crc32", at);
  isString(v6, at + ".crc32", PATTERN_4);
}
